import { useEffect, useState, type ReactNode } from 'react';

interface Props {
  src?: string;
  alt: string;
  className?: string;
  fallback: ReactNode;
}

// Item image with graceful degradation: renders the fallback when there is no
// src or the image fails to load. Consumers own the surrounding wrapper.
export const ItemThumbnail = ({ src, alt, className, fallback }: Props) => {
  const [showImage, setShowImage] = useState(!!src);

  useEffect(() => {
    setShowImage(!!src);
  }, [src]);

  if (!showImage) return <>{fallback}</>;

  return (
    <img
      className={className}
      src={src}
      alt={alt}
      loading='lazy'
      onError={() => setShowImage(false)}
    />
  );
};
